// extracted by mini-css-extract-plugin
export default {"image":"SpotlightCardLoadingSkeleton_image__ZKd7I","label":"SpotlightCardLoadingSkeleton_label__A2IM2","title":"SpotlightCardLoadingSkeleton_title__EDk36"};